/* GASSISA
=========================================================================================
* Descripcion: Version portatil del formulario de toma de inventario.
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revision   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 26/06/2026 | Lic. Jose Luis Aragon Cervantes  | Creacion de version portatil responsiva
* ---------------------------------------------------------------------------------------
*/

import FrmTomaInventario from "../../../inventarios/toma/FrmTomaInventario.jsx";
import SizeSoftXFrmPortatil from "../../leyout/SizeSoftXFrmPortatil.jsx";

export default function FrmTomaInventarioPortatil() {
  return (
    <SizeSoftXFrmPortatil nombreFormulario="FrmTomaInventario">
      <FrmTomaInventario />
    </SizeSoftXFrmPortatil>
  );
}
